import StandardHero from './standardHero'

export default StandardHero
